type JsonLdProps = {
  data: Record<string, unknown> | unknown[];
};

// Escape all `<` as Unicode `\u003c` to prevent </script>/<!--/<script breakout
// from any JSON-LD payload. Broader than `.replace(/<\/script>/gi, ...)` —
// covers HTML comment-start and any other `<` vector. Pattern used by Google's
// Closure library. Applied INSIDE the component so callers can never forget.
function safeJsonLdString(value: unknown): string {
  return JSON.stringify(value).replace(/</g, "\\u003c");
}

export function JsonLd({ data }: JsonLdProps) {
  const payload = Array.isArray(data) ? data : [data];

  return (
    <>
      {payload.map((entry, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: safeJsonLdString(entry) }}
        />
      ))}
    </>
  );
}
